import React from 'react';
type Tone = 'orange' | 'teal' | 'gold' | 'espresso';
type SkewTagProps = {
  children: React.ReactNode;
  tone?: Tone;
  shadow?: Tone;
  size?: 'sm' | 'lg';
  as?: 'span' | 'h2' | 'h3';
  id?: string;
  className?: string;
};
const fill: Record<Tone, string> = {
  orange: 'bg-foodOrange text-white',
  teal: 'bg-foodTeal text-white',
  gold: 'bg-foodGold text-foodMaroon',
  espresso: 'bg-foodMaroon text-foodCream'
};
const offset: Record<Tone, string> = {
  orange: 'shadow-[5px_5px_0px_0px_#F4631E]',
  teal: 'shadow-[5px_5px_0px_0px_#015C68]',
  gold: 'shadow-[5px_5px_0px_0px_#F6B303]',
  espresso: 'shadow-[5px_5px_0px_0px_#2A1B14]'
};

/** The slanted label from the print collateral, with its offset color block. */
export function SkewTag({
  children,
  tone = 'teal',
  shadow = 'gold',
  size = 'sm',
  as: Tag = 'span',
  id,
  className = ''
}: SkewTagProps) {
  const sizing = size === 'lg' ? 'px-6 py-2 text-xl sm:text-2xl' : 'px-4 py-1.5 text-sm';
  return <Tag id={id} className={`inline-block -skew-x-12 ${fill[tone]} ${offset[shadow]} ${sizing} ${className}`} data-id="element-311" data-mp="25leawj9nlduu">
      <span className="inline-block skew-x-12 font-display font-wide font-extrabold uppercase tracking-wide sm:whitespace-nowrap" data-id="element-312" data-mp="2alafokq6d9bg">
        {children}
      </span>
    </Tag>;
}